import { render, staticRenderFns } from "./app-info.vue?vue&type=template&id=204f97dd&scoped=true"
import script from "./app-info.vue?vue&type=script&lang=ts"
export * from "./app-info.vue?vue&type=script&lang=ts"
import style0 from "./app-info.vue?vue&type=style&index=0&id=204f97dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f97dd",
  null
  
)

export default component.exports